import { Controller } from 'react-hook-form';

import { DatePicker } from '#src/components/DatePicker/DatePicker.tsx';
import type { DateFormField } from '../../types.ts';

interface DateFieldProps {
  element: DateFormField;
}

export const DateField = ({ element }: DateFieldProps) => (
  <Controller
    key={element.id}
    name={element.id}
    rules={{
      validate: (value: string) => {
        if (value.length === 0) {
          return element.required ? 'This field is required' : true;
        }
        if (element.future) {
          return new Date(value) >= new Date()
            ? true
            : 'Provide a date and time in the future.';
        }
        if (element.past) {
          return new Date(value) <= new Date()
            ? true
            : 'Provide a date and time in the past.';
        }
      },
    }}
    render={({ field, fieldState }) => (
      <DatePicker
        name={element.id}
        type="datetime-local"
        onChange={(_, date) => field.onChange(date?.toISOString() ?? '')}
        value={field.value}
        max={element.past ? new Date() : undefined}
        min={element.future ? new Date() : undefined}
        label={element.label}
        secondaryLabel={element.secondaryLabel}
        errorMessage={fieldState.error?.message}
      />
    )}
  />
);
